import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputTextareaComponent } from './input-textarea.component';


@NgModule({
  declarations: [
    InputTextareaComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule
  ],
  exports: [
    InputTextareaComponent
  ]
})
export class InputTextareaModule {
}
